import { render } from "./form-student-activity.vue?vue&type=template&id=680aa39d&ts=true"
import script from "./form-student-activity.vue?vue&type=script&lang=ts"
export * from "./form-student-activity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__